import React from 'react';
import '../../styles/sections.css';
import '../../styles/overview.css';

const Overview = () => {
  return (
          <section className="overview-section">
        <div className="section-header">
          <h2>OVERVIEW</h2>
          <div className="underline"></div>
        </div>
        <div className="overview-content">
        <p>
          Swipe is a social media iOS application built with React Native and Expo for the frontend, 
          featuring a Go backend and PostgreSQL database. The app provides users with a modern social 
          media experience, allowing them to connect, share content, and interact with other users 
          through an intuitive mobile interface.
        </p>
        <p>
          The application leverages React Native's cross-platform capabilities to deliver a native iOS 
          experience, with frontend testing managed through Apple TestFlight for seamless beta distribution. 
          The Go backend API is deployed in production using AWS Lambda and API Gateway, ensuring serverless 
          scalability and cost-effective performance. For content moderation, image uploads are processed 
          through AWS Rekognition for automated content screening, and upon verification, images are stored 
          via IPFS Pinata nodes for decentralized, efficient storage. The PostgreSQL database runs on the 
          Neon platform in production, providing a fully managed database solution with automatic scaling 
          and backup capabilities.
        </p>
      </div>
    </section>
  );
};

export default Overview;

